import { ng } from '@uirouter/angularjs/lib/angular';
import * as angular from 'angular';

class WizardProductAndCategoryList implements ng.IController {
	static $inject = ['$translate'];

	constructor(
		protected $translate: angular.translate.ITranslateService,
	) {	}
}

angular.module('naut').component('wizardProductAndCategoryList', {
	template: require('./wizard-product-and-category-list.component.html'),
	controller: WizardProductAndCategoryList,
	controllerAs: 'ctrl',
	bindings: {
		onDelete: '&',
		items: '<',
		header: '<'
	}
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/nfc-stickers/wizard/wizard-products-step/wizard-product-and-category-list/wizard-product-and-category-list.component.ts